import Vue from 'vue'
import Vuex from 'vuex'
import attribute from "@/storages/vns/AttributeStore";
import credential from "@/storages/vns/CredentialStore";
import dexpara from "@/storages/dexpara/index";
import fileformat from "@/storages/vns/FileformatStore";
import functions from "@/storages/FunctionStore";
import integration from "@/storages/vns/IntegrationStore";
import integrationHelper from "@/storages/vns/integrationHelper";
import loinc from "@/storages/loinc/LoincStore";
import manufacturer from "@/storages/vns/ManufacturerStore";
import monitorFilter from "@/storages/vns/MonitorFilterStore";
import monitoringFilter from "@/storages/vns/MonitoringFilterStore";
import queueFilter from "@/storages/vns/QueueFilterStore";
import order from "@/storages/vns/OrderStore";
import performance from "@/storages/PerformanceStore";
import protocol from "@/storages/vns/ProtocolStore";
import ranges from "@/storages/vns/RangeStore";
import report from "@/storages/ReportStore";
import states from "@/storages/vns/StateStore";
import trigger from "@/storages/TriggerStore";
import tuevs from "@/storages/tuevs/TuevsStore";
import typeStorage from "@/storages/type/TypeStorage";
import vns from "@/storages/vns/VnsStore";
import queue from "@/storages/vns/QueueStore";
import protocolSettings from "@/storages/vns/ProtocolSettingStore";
import rnds from "@/storages/RndsStore";
import interopera from "@/storages/InteroperaStore";
import corecompanies from "@/storages/CoreCompaniesStore";
import corecareunits from "@/storages/CoreCareUnitsStore";
import coresectors from "@/storages/CoreSectorsStore";
import container_support from "@/storages/ContainerSupportStore";
import recipient from "@/storages/monitorExams/RecipientStore";
import file from "@/storages/monitorExams/FileStore";
import reportTrash from "@/storages/vns/ReportTrashStore";
import reportControl from "@/storages/vns/ReportControlStore";
import audit from "@/storages/audit/AuditStore";
import logFilter from "@/storages/audit/LogFilterStore";
import reportEditable from "@/storages/vns/ReportEditableStore";
import reviewObservation from "@/storages/ReviewObservationStore";
import reviewObservationFilter from "@/storages/vns/ReviewObservationFilterStore";

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        attribute,
        credential,
        dexpara,
        fileformat,
        functions,
        integration,
        integrationHelper,
        loinc,
        manufacturer,
        monitorFilter,
        monitoringFilter,
        queueFilter,
        order,
        performance,
        protocol,
        ranges,
        report,
        states,
        trigger,
        tuevs,
        type: typeStorage,
        vns,
        queue,
        protocolSettings,
        rnds,
        interopera,
        corecompanies,
        corecareunits,
        coresectors,
        container_support,
        recipient,
        file,
        reportTrash,
        reportControl,
        audit,
        logFilter,
        reportEditable,
        reviewObservation,
        reviewObservationFilter
    }
})